/* global api */
import * as types from './authentication-mutation-types'
import { User, LogEntry } from '../../models'

// state
const state = {
  user: null,
  orgPrimaryBranchId: null,
  orgState: null,
  simulatingUser: false
}

// mutations
const mutations = {
  [types.FETCH_USER_SUCCESS] (state, { user, store = true }) {
    state.user = user
    if (store) {
      window.sessionStorage.setItem('user', JSON.stringify(user))
    }
  },

  // [types.FETCH_USER_FAILURE] (state) {
  //   state.token = null
  //   Cookies.remove('token')
  // },

  [types.LOGOUT] (state) {
    state.user = null
  },
  commitOrgPrimaryBranchId (state, meta) {
    if (state.orgPrimaryBranchId === null) {
      state.orgPrimaryBranchId = parseInt(meta)
    }
  },
  commitResetBranchId (state) {
    state.orgPrimaryBranchId = null
  },
  commitOrgState (state, meta) {
    if (state.orgState === null) {
      state.orgState = meta
    }
  },
  commitResetState (state) {
    state.orgState = null
  },
  commitSetSimulatingUser (state, meta) {
    state.simulatingUser = meta
  }
}

// actions
const actions = {
  async initialiseStore ({ commit }) {
    if (window.sessionStorage.getItem('user')) {
      const user = await JSON.parse(window.sessionStorage.getItem('user'))
      await commit(types.FETCH_USER_SUCCESS, { user: user, store: false })
    }
  },

  async login ({ commit, dispatch, rootState }, meta) {
    try {
      const method = 'post'
      const result = await api.call(method, rootState.apiUrl + 'login', meta)
      if (result.success && result.message !== null) {
        await commit(types.FETCH_USER_SUCCESS, { user: result.message })
        await dispatch('setShowInit', true, { root: true })
        if (rootState.isSelf) {
          const branch = rootState.branch
          await dispatch('simulateBranchId', branch)
        }
      }

      const logEntry = new LogEntry('authentication/login', 'Login ' + meta.username + ': ' + result.success)
      await dispatch('support/addLog', logEntry, { root: true })
      return result.success
    } catch (error) {
      const logEntry = new LogEntry('authentication/login error', error)
      await dispatch('support/addLog', logEntry, { root: true })

      console.log('login error')
      console.log(error)
    }
  },

  async logout ({ commit, dispatch, rootState }) {
    try {
      dispatch('setApplicationReady', false, { root: true }).then(async () => {
        const logEntry = new LogEntry('authentication/logout', 'User logout')
        await dispatch('support/addLog', logEntry, { root: true })
        await dispatch('setInitProgress', 0, { root: true })
        commit('commitDeactivateSelfSignInLogin', null, { root: true })
        commit('commitDeactivateBfmLogin', null, { root: true })
        await commit(types.LOGOUT)
        // localForage.setItem('cached_branch', cachedBranch)
        window.sessionStorage.clear()
        window.location = 'login'
      })
    } catch (error) {
      const logEntry = new LogEntry('authentication/logout error', error)
      await dispatch('support/addLog', logEntry, { root: true })

      console.log('logout error')
      console.log(error)
    }
  },

  async fetchUser ({ commit, dispatch, rootState }, meta) {
    try {
      const metaLogEntry = new LogEntry('authentication/fetchUser meta', meta)
      await dispatch('support/addLog', metaLogEntry, { root: true })

      const method = 'post'
      const result = await api.call(method, rootState.apiUrl + 'fetchUser', meta, this)
      commit(types.FETCH_USER_SUCCESS, { user: result.message })
      return result.success
    } catch (error) {
      const logEntry = new LogEntry('authentication/fetchUser error', error)
      await dispatch('support/addLog', logEntry, { root: true })

      console.log('fetchUser error')
      console.log(error)

      commit(types.FETCH_USER_FAILURE)
    }
  },

  async simulateBranchId ({ commit, state }, meta) {
    const simulatedUser = state.user
    await commit('commitOrgPrimaryBranchId', simulatedUser.C_branch_item_id_primary)
    simulatedUser.C_branch_item_id_primary = parseInt(meta)
    await commit(types.FETCH_USER_SUCCESS, { user: simulatedUser })
  },

  async resetBranchId ({ commit, state }) {
    const simulatedUser = state.user
    simulatedUser.C_branch_item_id_primary = parseInt(state.orgPrimaryBranchId)
    await commit(types.FETCH_USER_SUCCESS, { user: simulatedUser })
    await commit('commitResetBranchId')
  },

  async simulateState ({ commit, state }, meta) {
    const simulatedUser = state.user
    await commit('commitOrgState', simulatedUser.state)
    simulatedUser.state = meta.toUpperCase()
    await commit(types.FETCH_USER_SUCCESS, { user: simulatedUser })
  },

  async resetState ({ commit, state }) {
    const simulatedUser = state.user
    simulatedUser.state = state.orgState
    await commit(types.FETCH_USER_SUCCESS, { user: simulatedUser })
    await commit('commitResetState')
  }
}

// getters
const getters = {
  user: state => (state.user !== null) ? new User(state.user) : {},
  check: state => state.user !== null,
  simulateBranchId: state => state.orgPrimaryBranchId !== null,
  simulatedBranchId: state => state.orgPrimaryBranchId,
  simulateState: state => state.orgState !== null,
  simulatingUser: state => state.simulatingUser
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
